import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  Typography,
} from '@mui/material';
import { IModuleMenu } from './interfaces';
import { ModuleMenuItem } from '../ModuleMenuItem';
import { useTranslation } from 'react-i18next';

export const ModuleMenu: React.FC<IModuleMenu> = ({
  show,
  modules,
  active,
  onClose,
  onClick,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={show} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {t('modules:switcher.title')}
        <Typography variant="body2" color="text.secondary">
          {t('modules:switcher.info')}
        </Typography>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          pt: '5px',
        }}
      >
        <List>
          {modules.map((module) => (
            <ModuleMenuItem
              key={module.id}
              title={module.title}
              subTitle={module.subTitle}
              icon={module.icon}
              onClick={() => onClick(module)}
              active={module === active}
            />
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};
